/* ============
 * Vue i18n
 * ============
 *
 * Internationalization plugin of Vue.js.
 *
 * https://kazupon.github.io/vue-i18n/
 */

import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from '../locale';
import dateTimeFormats from "../locale/dateTimeFormats";

Vue.use(VueI18n);

// Временно всегда устанавливаем русский язык, перезаписывая настройки.
let language = 'ru';
localStorage.setItem('language', language);

// if (localStorage.getItem('language') === null) {
//   // Пока скрываем возможность переключения языка и подтягивание его при старте из системной локали.
//   // language = window.navigator.language.slice(0, 2);
//   language = 'ru';
//   localStorage.setItem('language', language);
// } else {
//   language = localStorage.getItem('language');
// }

export const i18n = new VueI18n({
  locale: localStorage.getItem('language') || 'ru',
  messages,
  dateTimeFormats
});

export default {
  i18n,
};
